import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IIncomeExpenseAccount } from "src/models/Stores/IncomeExpenseAccount.models";

interface IncomeExpenseAccountState {
  incomeExpenseAccounts: IIncomeExpenseAccount[];
  incomeExpenseAccountToEdit: IIncomeExpenseAccount | null;
}

const initialState: IncomeExpenseAccountState = {
  incomeExpenseAccounts: [],
  incomeExpenseAccountToEdit: null,
};

const incomeExpenseAccountSlice = createSlice({
  name: "IncomeExpenseAccount",
  initialState,
  reducers: {
    setIncomeExpenseAccountList: (
      state,
      action: PayloadAction<IIncomeExpenseAccount[]>
    ) => {
      state.incomeExpenseAccounts = action.payload;
    },
    concatListIncomeExpenseAccount: (
      state: IncomeExpenseAccountState,
      action: PayloadAction<IIncomeExpenseAccount[]>
    ) => {
      state.incomeExpenseAccounts = [
        ...state.incomeExpenseAccounts.concat(action.payload),
      ];
    },
    setIncomeExpenseAccountToEdit: (
      state,
      action: PayloadAction<IIncomeExpenseAccount | null>
    ) => {
      state.incomeExpenseAccountToEdit = action.payload;
    },
    addIncomeExpenseAccount: (
      state,
      action: PayloadAction<IIncomeExpenseAccount>
    ) => {
      state.incomeExpenseAccounts.push(action.payload);
    },
    updateIncomeExpenseAccount: (
      state,
      action: PayloadAction<IIncomeExpenseAccount>
    ) => {
      let itemIndex = state.incomeExpenseAccounts.findIndex(
        item =>
          item.incomeExpenseAccountId === action.payload.incomeExpenseAccountId
      );
      if (itemIndex !== -1)
        state.incomeExpenseAccounts[itemIndex] = action.payload;
    },
    deleteIncomeExpenseAccount: (state, action: PayloadAction<number>) => {
      const newArray = state.incomeExpenseAccounts.filter(
        item => item.incomeExpenseAccountId !== action.payload
      );
      state.incomeExpenseAccounts = newArray;
    },
  },
});

export const {
  setIncomeExpenseAccountList,
  concatListIncomeExpenseAccount,
  setIncomeExpenseAccountToEdit,
  addIncomeExpenseAccount,
  updateIncomeExpenseAccount,
  deleteIncomeExpenseAccount,
} = incomeExpenseAccountSlice.actions;

export default incomeExpenseAccountSlice.reducer;
